"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importStar(require("styled-components"));
const Section = styled_components_1.default.div `
  margin: ${props => props.theme.spacing.medium} 0;

  ${props => props.tight &&
    styled_components_1.css `
      margin: ${props => props.theme.spacing.small} 0;
    `};

  ${props => props.hugTop &&
    styled_components_1.css `
      margin-top: 0;
    `};

  ${props => props.hugBottom &&
    styled_components_1.css `
      margin-bottom: 0;
    `};
`;
exports.default = Section;
